// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"3f1bb2fe","739":"967bc352"}[chunkId] + ".chunk.js";
};